import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';

import { backendOptions } from '@/js/libs/i18n-tools';

import { supportedLanguages } from './constants';
import { lowercaseWord } from './utils/string';

enum Formatter {
  LOWERCASE_WORD = 'lowercaseWord',
}

const TRANSLATION_CACHE_ENABLED = import.meta.env.VITE_IS_TRANSLATION_CACHE_ENABLED === 'true';

const Backend = new ChainedBackend(null, {
  backends: [...(TRANSLATION_CACHE_ENABLED ? [LocalStorageBackend] : []), HttpApi],
  backendOptions: [
    ...(TRANSLATION_CACHE_ENABLED
      ? [
          {
            // reset language cache every 6h
            expirationTime: 10 * 60 * 1000,
            // reset language cache on every deployment
            defaultVersion: window.audienzzGlobals.COMMITHASH,
          },
        ]
      : []),
    backendOptions,
  ],
});

i18n
  .use(LngDetector)
  .use(Backend)
  .init({
    returnNull: false,
    debug: localStorage.getItem('is-i18n-debug-mod-enabled') === 'true',
    supportedLngs: supportedLanguages,
    fallbackLng: false,
    load: 'currentOnly',
    preload: false,
    keySeparator: false,
    returnEmptyString: false,
    saveMissing: true,
    fallbackNS: 'backend',
  });

i18n.services.formatter?.add(Formatter.LOWERCASE_WORD, lowercaseWord);

// preload messages namespace since its used directly in i18n.t calls
i18n.loadNamespaces('messages', (err) => {
  if (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  } else {
    // eslint-disable-next-line no-console
    console.log('preloaded namespaces');
  }
});

export const translate = (key: string): Promise<string> => {
  const ns = key.split(':')[0];
  if (!ns) throw new Error(`Invalid key: ${key}`);
  return i18n.loadNamespaces(ns).then(() => i18n.t(key));
};

export default i18n;
